import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import MuiLink from '@material-ui/core/Link'
import Grid from '@material-ui/core/Grid'
import clsx from 'clsx'
import Link from 'next/link'

const useStyles = makeStyles((theme) => ({
    root: {
        height: '23vh',
        display: 'flex',
        alignItems: 'center',
        backgroundColor:
            theme.palette.type === 'light'
                ? theme.palette.grey[200]
                : theme.palette.secondary.main,
    },

    center: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    number: {
        fontFamily: "'Mercury', sans-sarif",
        fontWeight: theme.typography.fontWeightRegular,
        marginTop: theme.spacing(1.4),
        cursor: 'pointer',
    },
}))

const ContactBand = ({}) => {
    const classes = useStyles()

    return (
        <div className={classes.root}>
            <Container className={classes.center}>
                <Grid container item spacing={5}>
                    <Grid item xs={12} md={8}>
                        <Typography variant="h4" color="secondary">
                            Call us to book a showing:
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4} container direction="column">
                        <Typography variant="h4" color="secondary">
                            MASE RASTI
                        </Typography>
                        <Link href="tel:+16478782221">
                            <Typography
                                variant="h4"
                                className={classes.number}
                                color="primary"
                            >
                                (647)-878-2221
                            </Typography>
                        </Link>
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

export default ContactBand
